import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import Themes from '../Themes';
import translations from '../../translations';

function PreviewHero() {
  const { theme } = useParams();
  const Components = Themes[theme];
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'en');
  const t = translations[language];

  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);

  const groomName = "Jacob";
  const brideName = "Sofea";
  const weddingDate = tomorrow;
  const weddingDay = getDayFromDate(weddingDate);

  const formattedDate = weddingDate.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  // Function to calculate the day from a given date (US English format)
  function getDayFromDate(date) {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const dayIndex = date.getDay();
    localStorage.setItem('Day', days[dayIndex]);
    return days[dayIndex];
  }

  const heroStyle = {
    backgroundImage: `url(${Components.bg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  };

  const center = {
    backgroundImage: `url(${Components.fc})`,
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  };

  const H2 = Components.H2;
  const fontP = Components.fontP;
  const H2size = Components.H2size;

  return (
    <div className="h-screen relative flex flex-col justify-center items-center overflow-hidden" style={heroStyle}>
      <div className={Components.fcStyle} style={center}>
        <p className={`text-sm ${fontP} uppercase md:w-1/2 mx-auto`}>{t.weInviteYou}</p>
        <div className={Components.centerText}>
          <h2 className={`${H2size} ${H2} capitalize`}>
            {groomName}
          </h2>
          <p className={`text-3xl ${H2} capitalize my-2`}>&</p>
          <h2 className={`${H2size} ${H2} capitalize`}>
            {brideName}
          </h2>
        </div>
        <div>
          <p className={`text-sm ${fontP}`}>{weddingDay}, {formattedDate}</p>
        </div>
      </div>
      <img
        src={Components.ft}
        className={Components.ftStyle}
      />
      <img
        src={Components.fb}
        className={Components.fbStyle}
      />
    </div>
  );
}

export default PreviewHero;
